import React, { useState, useEffect, useCallback } from "react";
import FormBuilderOffcanvas from "./FormBuilderOffcanvas";
import { useNavigate } from "react-router-dom";
import { getNormalQuestionaireFormList, deleteNormalQuestionaireForm } from "../../../services/CommonService";
import { toast } from "react-toastify";
import "./SmartQuestionaire.css";

function NormalQuestionnaire() {
  const [formObj, setFormObj] = useState({});
  const [loading, setLoading] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [forms, setForms] = useState([]);
  const [sleeveDetails, setSleeveDetails] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editFormData, setEditFormData] = useState(null);
  const [previewFormData, setPreviewFormData] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [selectedPreviewGroupIdx, setSelectedPreviewGroupIdx] = useState(0);
  const navigate = useNavigate();
  const [dragIndex, setDragIndex] = useState(null);

  // Drag and Drop Handlers
  const handleDragStart = (index) => {
    setDragIndex(index);
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    // Optionally, add some visual feedback
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    if (dragIndex === null || dragIndex === dropIndex) return;
    const updatedForms = [...forms];
    const [removed] = updatedForms.splice(dragIndex, 1);
    updatedForms.splice(dropIndex, 0, removed);
    setForms(updatedForms);
    setDragIndex(null);
  };

  const handleDragEnd = () => {
    setDragIndex(null);
  };

  const handleOpenOffcanvas = () => {
    setEditMode(false);
    setEditFormData(null);
    setShowOffcanvas(true);
  };

  const fetchForms = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getNormalQuestionaireFormList({});

      if (response.data?.data) {
        setForms([...response.data?.data]);
      } else {
        setForms([]);
      }
    } catch (error) {
      console.error("Error fetching forms:", error);
      setForms([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  useEffect(() => {
    fetchForms();
  }, [fetchForms]);

  const handleEditForm = (form) => {
    setEditFormData({
      ...form,
      smart_form_name: form.form_name,
      smart_questionaire_uuid: formObj.smart_questionaire_uuid
    });
    setEditMode(true);
    setShowOffcanvas(true);
  };

  const handleCopyForm = (form) => {
    console.log("Original form to copy:", form);
    const copiedForm = JSON.parse(JSON.stringify(form));

    // Clear all IDs to ensure it creates a new form
    delete copiedForm.form_id;
    delete copiedForm.form_uuid;
    delete copiedForm.smart_questionaire_id;
    copiedForm.form_name = "";

    if (copiedForm.groups) {
      copiedForm.groups = copiedForm.groups.map(group => {
        const newGroup = { ...group };
        delete newGroup.group_id;
        newGroup.questions = (group.questions || []).map(q => {
          const newQuestion = { ...q };
          delete newQuestion.question_id;
          if (newQuestion.options) {
            newQuestion.options = newQuestion.options.map(opt => {
              const newOption = { ...opt };
              delete newOption.option_id;
              delete newOption.id;
              return newOption;
            });
          }
          return newQuestion;
        });
        return newGroup;
      });
    }

    const finalFormData = {
      ...copiedForm,
      smart_form_name: "",
      smart_questionaire_uuid: formObj.smart_questionaire_uuid
    };

    console.log("Copied form data being passed to FormBuilder:", finalFormData);
    setEditFormData(finalFormData);
    setEditMode(true);
    setShowOffcanvas(true);
  };

  const handleDeleteForm = async (form) => {
    setForms(prevForms => prevForms.filter(f => f.form_uuid !== form.form_uuid));

    try {
      const response = await deleteNormalQuestionaireForm({ form_uuid: form.form_uuid });
      if (!response.data.message) {
        setForms(prevForms => [...prevForms, form]);
        toast.error(response.data.message || "Failed to delete form");
      } else {
        toast.success("Form deleted successfully!");
        await fetchForms();
      }
    } catch (error) {
      setForms(prevForms => [...prevForms, form]);
      console.error("Error deleting form:", error);
      toast.error(error.response?.data?.message || error.message || "Error deleting form");
    }
  };

  const handleFormSaved = async () => {
    setLoading(true);
    await fetchForms();
    setLoading(false);
  };

  const handlePreviewForm = (form) => {
    setPreviewFormData(form);
    setShowPreviewModal(true);
  };
  const handleClosePreviewModal = () => {
    setShowPreviewModal(false);
    setPreviewFormData(null);
  };

  function onBack(e) {
    e.preventDefault();
    const formData = { ...formObj };
    if (!formData.recipient_list && formObj.recipient_list) {
      formData.recipient_list = formObj.recipient_list;
    }
    if (!formData.due_date && formObj.due_date) {
      formData.due_date = formObj.due_date;
    }
    formData.current_step = 1;
    setFormObj(formData);
    navigate(`/client-portal`);
  }



  if (showSuccess) {
    return (

      <div className="d-flex justify-content-center align-items-center" style={{ marginTop: "5%" }}>
        <div className="bg-white p-5 rounded-1 shadow text-center">
          <div className="mb-3">
            <div style={{ width: 80, height: 80, margin: '0 auto', background: '#e6f9ed', borderRadius: "6px", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <i className="bi bi-check2-circle" style={{ color: '#22c55e', fontSize: 48 }}></i>
            </div>
          </div>
          <h2 className="fw-bold mb-3">Your Questionnaire has been Successfully Sent!</h2>
          <div className="d-flex flex-column flex-sm-row justify-content-center gap-3 py-3">
            <button
              className="btn btn-outline-primary px-4 py-2 rounded-1 fw-medium d-flex align-items-center justify-content-center"
              onClick={() => navigate('/client-portal/smart-questionnaire/manage')}
              style={{
                minWidth: '220px',
                transition: 'all 0.3s ease',
                borderWidth: '2px'
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = ''}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = ''}
            >
              <i className="bi bi-eye-fill fs-5 me-2"></i>
              <span>View Questionnaire</span>
            </button>

            <button
              className="btn btn-primary px-4 py-2 rounded-1 fw-medium d-flex align-items-center justify-content-center"
              onClick={() => navigate('/client-portal/smart-questionnaire')}
              style={{
                minWidth: '220px',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 8px rgba(0, 0, 0, 0.15)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = '';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
              }}
            >
              <i className="bi bi-plus-circle-fill fs-5 me-2"></i>
              <span>Create New</span>
            </button>
          </div>
        </div>
      </div>

    );
  }

  return (
    <>
      {loading && <div className="page-loading">
        <img src="/images/loader.gif" alt="loader" />
      </div>}

      <div className="section-bg-color" style={{ minHeight: "calc(100vh - 93px)", paddingTop: "80px" }}>
        <div className="smart-questionaire-step2 mt-5 p-4 sleeve-step">
          <div>
            <div className="row">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center">
                  <h2>Build Your Questionnaire</h2>
                  <button type="button" className="btn btn-primary" onClick={handleOpenOffcanvas}>
                    <i className="bi bi-plus-lg me-2"></i>
                    Create
                  </button>
                </div>

                {/* Sleeve Info */}
                {sleeveDetails && (
                  <div className="card mb-4">
                    <div className="card-body">
                      <h5 className="card-title">Sleeve Information</h5>
                      <div className="row">
                        <div className="col-md-6">
                          <p><strong>Name:</strong> {sleeveDetails.sleeve_name}</p>
                        </div>
                        <div className="col-md-6">
                          <p><strong>Due Date:</strong> {new Date(sleeveDetails.due_date).toLocaleDateString()}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Forms List */}
                <div className="card my-3">
                  <div className="card-body">
                    {forms.length === 0 ? (
                      <div className="text-center py-3 smartq-empty-state">
                        <i className="bi bi-file-earmark-text display-2 text-muted"></i>
                        <h4 className="mt-3">No Questionnaire  Created Yet</h4>
                        <p className="text-muted">Click the <span className="fw-bold">Create </span> button to get started</p>
                      </div>
                    ) : (
                      <div className="row smartq-form-cards-row">
                        {forms.map((form, idx) => (
                          <div key={form.form_id} className="col-12 mb-4"
                            draggable
                            onDragStart={() => handleDragStart(idx)}
                            onDragOver={(e) => handleDragOver(e, idx)}
                            onDrop={(e) => handleDrop(e, idx)}
                            onDragEnd={handleDragEnd}
                            style={{ opacity: dragIndex === idx ? 0.5 : 1, cursor: 'move' }}
                          >
                            <div className="card smartq-form-card h-100 shadow-sm">
                              <div className="card-body p-3">
                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="fw-bold smartq-form-title d-flex align-items-center" style={{ minWidth: 0, flex: 1, textAlign: "left" }}>
                                    <span className="me-2" style={{ cursor: 'grab', fontSize: 20, color: '#888' }} title="Drag to reorder">
                                      <i className="bi bi-grip-vertical"></i>
                                    </span>
                                    {form.form_name}
                                  </div>
                                  <div className="text-center" style={{ flex: 1 }}>
                                    <div>
                                      <span className="me-3 badge bg-primary text-white">
                                        <b>{form.groups.reduce((acc, g) => acc + (g.questions?.length || 0), 0)}</b> Questions
                                      </span>
                                      <span className="badge bg-secondary text-white">
                                        <b>{form.groups.length}</b> Groups
                                      </span>
                                    </div>
                                  </div>
                                  <div className="d-flex gap-2" style={{ flex: 1, justifyContent: "flex-end" }}>
                                    <button
                                      type="button"
                                      className="btn btn-light btn-sm rounded-circle shadow-sm icon-action-btn"
                                      title="Click to Preview"
                                      data-toggle="tooltip"
                                      onClick={() => handlePreviewForm(form)}
                                      style={{ width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                    >
                                      <i className="bi bi-eye"></i>
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-light btn-sm rounded-circle shadow-sm icon-action-btn"
                                      title="Click to Copy"
                                      data-toggle="tooltip"
                                      onClick={() => handleCopyForm(form)}
                                      style={{ width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                    >
                                      <i className="bi bi-files"></i>
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-light btn-sm rounded-circle shadow-sm icon-action-btn"
                                      title="Click to Edit"
                                      data-toggle="tooltip"
                                      onClick={() => handleEditForm(form)}
                                      style={{ width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                    >
                                      <i className="bi bi-pencil"></i>
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-light btn-sm rounded-circle shadow-sm icon-action-btn"
                                      title="Click to Delete"
                                      data-toggle="tooltip"
                                      onClick={() => handleDeleteForm(form)}
                                      style={{ width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                    >
                                      <i className="bi bi-trash"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>



                {/* Step navigation buttons */}
                <div className="smartq-step-nav-sticky">
                  <div className="">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center smartq-step-nav">
                      <button type="button" className="sleeve-btn-back" onClick={onBack}>
                        <i className="bi bi-arrow-left me-2"></i>
                        Back
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div >

          <FormBuilderOffcanvas
            show={showOffcanvas}
            onClose={() => {
              setShowOffcanvas(false);
              setEditMode(false);
              setEditFormData(null);
            }}
            sleeve_uuid={formObj?.smart_questionaire_uuid}
            onFormSaved={handleFormSaved}
            loading={loading}
            setLoading={setLoading}
            editMode={editMode}
            editFormData={editFormData}
            formObj={formObj}
            questionnaireType="normal"
          />


          {/* Preview Modal */}
          {showPreviewModal && (
            <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)' }} tabIndex="-1" role="dialog">
              <div className="modal-dialog modal-xl" role="document">
                <div className="modal-content rounded-1 overflow-hidden">
                  {/* Modal Header */}
                  <div className="modal-header">
                    <div className="d-flex align-items-center">
                      <h4 className="modal-title fw-bold mb-0">Preview: {previewFormData?.form_name}</h4>
                    </div>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={handleClosePreviewModal}
                      aria-label="Close"
                    >
                      <i className="bi bi-x"></i>
                    </button>
                  </div>

                  {/* Modal Body */}
                  <div className="modal-body p-0">
                    {previewFormData?.groups && (
                      <div className="row g-0 h-100">
                        {/* Sidebar: Groups */}
                        <div className="col-md-3 bg-light">
                          <div className="p-3 h-100 d-flex flex-column">
                            <h5 className="fw-semibold text-muted mb-3">Form Sections</h5>
                            <div className="flex-grow-1 overflow-auto">
                              {previewFormData.groups.map((group, idx) => (
                                <div
                                  key={group.group_id || idx}
                                  className={`p-3 mb-2 rounded-1 cursor-pointer group-item ${selectedPreviewGroupIdx === idx ? 'bg-white shadow-sm border border-primary' : 'hover-bg'}`}
                                  onClick={() => setSelectedPreviewGroupIdx(idx)}
                                >
                                  <div className="d-flex align-items-center">
                                    <span className="badge bg-primary rounded-circle me-2 d-flex align-items-center justify-content-center" style={{ width: '24px', height: '24px' }}>
                                      {idx + 1}
                                    </span>
                                    <span className="fw-medium text-truncate">{group.group_name}</span>
                                  </div>
                                  {group.questions?.length > 0 && (
                                    <small className="text-muted ms-4">{group.questions.length} questions</small>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>

                        {/* Questions Panel */}
                        <div className="col-md-9 p-4" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                          <div className="d-flex align-items-center mb-4">
                            <i className="bi bi-collection-fill text-primary fs-4 me-2"></i>
                            <h4 className="fw-bold mb-0">
                              {previewFormData.groups[selectedPreviewGroupIdx]?.group_name}
                            </h4>
                          </div>

                          {previewFormData.groups[selectedPreviewGroupIdx]?.questions && (
                            <div className="row g-3">
                              {previewFormData.groups[selectedPreviewGroupIdx].questions.map((q, qidx) => (
                                <div key={q.question_id || qidx} className="col-12">
                                  <div className="card border-1 rounded-1 p-4 hover-shadow transition-all">
                                    <div className="d-flex justify-content-between align-items-start">
                                      <div className="flex-grow-1">
                                        <div className="d-flex align-items-center mb-2">
                                          <span className="badge bg-light text-primary fw-bold me-2">Q{qidx + 1}</span>
                                          <span className="fw-semibold">{q.question_text}</span>
                                          {q.is_required && (
                                            <span className="badge bg-danger ms-2">Required</span>
                                          )}
                                        </div>

                                        {/* Question Type Indicator */}
                                        <div className="d-flex align-items-center mt-2">
                                          <span className="badge bg-light text-dark border me-2 d-flex align-items-center">
                                            <i className="bi bi-tag-fill text-muted me-1"></i>
                                            {q.question_type}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="modal-footer border-top">
                    <button
                      type="button"
                      className="btn btn-outline-secondary px-4 rounded-1"
                      onClick={handleClosePreviewModal}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default NormalQuestionnaire; 